export default __webpack_public_path__ + "static/media/IMG_8818.d4ebe604.jpg";